import React from 'react';

const LoadingScreen: React.FC = () => {
  return (
    <div className="h-screen flex flex-col items-center justify-center bg-background text-foreground">
      <div className="logo-container">
        <img src="/logo.png" alt="Logo" className="logo-spinner" />
      </div>
      <p className="mt-6 text-lg text-gray-500">Carregando...</p>
    </div>
  );
};

export default LoadingScreen;